import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 min (same as old cacheManager)
            retry: 1,
            refetchOnWindowFocus: false
        }
    }
});

export function Providers({ children }: { children: ReactNode }) {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ErrorBoundary>
    );
}
